import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    open: boolean;
    title: string;
    description?: string;
    loading?: boolean;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onClose: () => void;
};

export default function ConfirmationDialog({
    open,
    title,
    description,
    loading,
    confirmText,
    cancelText,
    onConfirm,
    onClose,
}: Props) {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={loading ? undefined : onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {description ? <Typography sx={{ mt: 1 }}>{description}</Typography> : null}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit" disabled={!!loading}>
                    {cancelText ?? t('dialog.cancel')}
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained" disabled={!!loading}>
                    {loading ? t('dialog.deleting') : (confirmText ?? t('dialog.confirm'))}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
